import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { RequestOptions } from '../modal/RequestOptions';
import { environment } from '../../environments/environments';
import { orgao } from '../modal/regional/orgao';
import { parametroHeader } from '../modal/parametroHeader';

@Injectable({
  providedIn: 'root',
})
export class ParametroHeaderService {
  constructor(private http: HttpClient) {}
  private apiUrl = environment.API_URL;
  private map = "ss.parametro.header";

  get(): Observable<any> {
    return this.http.get(this.apiUrl+this.map+'/buscarParametrosHeader', {withCredentials: true});
  }

  adicionarItem(item: parametroHeader, novoCad: boolean): Observable<parametroHeader> {
    let login = localStorage.getItem('login');
    return this.http.post<parametroHeader>(this.apiUrl+this.map+'/saveParametrosHeader?nomeUsuario='+login+"&novoCad="+novoCad, item, {withCredentials: true});
  }

  deleteItem(id: string): Observable<any> {
    let login = localStorage.getItem('login');
    return this.http.delete<any>(`${this.apiUrl}${this.map}/deletar?nomeUsuario=`+login+`&id=${id}`);
  }

  editarItem(id: string): Observable<any> {
    return this.http.get<any>(`${this.apiUrl}${this.map}/buscaParametroHeaderId/${id}`);
  }

  buscarParametrosHeaderAtivobyTipo(tipo: string): Observable<any> {
    return this.http.get<any>(`${this.apiUrl}${this.map}/buscarParametrosHeaderAtivosTipo/${tipo}`);
  }
}
